import "./index.scss";

import React from "react";
import { connect } from "react-redux";

import { postData, putData, deleteData, showToast } from "Source/globalFunction";

import Member from "./Member/Member";
import Search from "./Actions/Search/Search";

const mapUpdatedWorkstreamMembers = (workstreamId, workstreams, updatedWorkstream) => {
    return workstreams.map(w => {
        if(w.id === workstreamId) {
            return {
                ...w,
                lead: updatedWorkstream.lead,
                workstreamMembers: updatedWorkstream.workstreamMembers
            }
        }

        return w;
    })
}

const mapListMemberFormat = (member) => {
    return {
        ...member,
        userTypeLinkId: member.id,
        firstName: member.fullName,   
        lastName: '', 
        user: {
            firstName: member.fullName,   
            lastName: '', 
            avatar: member.avatar,
        }
    }
}

@connect(store => {
    return {
        workstreams: store.workstreams,
    };
})

class ManageMembers extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isClose: false
        }
    }

    render() {
        const { workstreams, dispatch, projectId} = this.props;
        const workstreamMembers = (workstreams.selected.members || []);
        const removedUsers = workstreamMembers.filter(m => m.isRemoved && !m.isNew);
        const newUsers = workstreamMembers.filter(m => m.isNew && !m.isRemoved);
        const previousLead = workstreamMembers.filter(m => m.isWorkstreamLead);
        const newLead = workstreamMembers.filter(m => m.isNewLead);
        const hasChanges = removedUsers.length > 0 || newLead.length > 0  || newUsers.length > 0 || (workstreams.selected.toUpdate && workstreams.selected.toUpdate.length>0);

        const handleDeleteMembers = async () => {
            if(removedUsers.length > 0) {
                const url = `/api/workstream/workstreamMembers/${workstreams.selected.id}`;
                const removedUserIds = removedUsers.map(m => m.id);
                const params = { userIds: removedUserIds.join(",") };

                return await new Promise((resolve) => {
                    deleteData(url, {params}, response => {
                        dispatch(
                            {type: "UPDATE_WORKSTREAMS_LIST", 
                            list: workstreams.list.map(ws => {
                                if(ws.id === workstreams.selected.id) {
                                    return {
                                        ...ws,
                                        lead: newLead?.length 
                                            ? mapListMemberFormat(newLead[0])
                                            : ws.lead,
                                        workstreamMembers: ws.workstreamMembers.filter(wsm => !removedUserIds.includes(wsm.userTypeLinkId))
                                    }
                                }

                                return ws;
                            })
                        });

                        resolve(true);
                    });
                });
            } else {
                return true;
            }
        }

        const handleUpdateMembers = async () => {
            if(newLead.length > 0) {
                const url = `/api/workstream/changeWorkstreamLead/${workstreams.selected.id}`;
                const data = { oldWorkstreamLead: previousLead.length? previousLead[0].id: null, newWorkstreamLead: newLead[0].id };

                return await new Promise((resolve) => {
                    putData(url, data, response => {
                        if(response) {
                            dispatch({
                                type: "UPDATE_WORKSTREAMS_LIST",
                                list: workstreams.list.map(ws => {
                                    if (ws.id === workstreams.selected.id) {
                                        return {
                                            ...ws,
                                            lead: mapListMemberFormat(newLead[0]),
                                            members: ws.workstreamMembers.map(wsm => {
                                                if (wsm.user.id === newLead[0].id) {
                                                    return {
                                                        ...wsm,
                                                        isWorkstreamLead: true,
                                                    } 
                                                }

                                                return {
                                                    ...wsm,
                                                    isWorkstreamLead: false,
                                                }
                                            })
                                        }
                                    }

                                    return ws;
                                }),
                            });

                            resolve(true);
                        }
                    });
                });
            } else {
                return true;
            }
        }

        const handleAddMembers = async () => {
            if(newUsers.length > 0) {
                const url = "/api/workstream/addWorkstreamMembers";
                const data = { workstreamId: workstreams.selected.id, userIds: newUsers.map(m => m.id), projectId:projectId };

                return await new Promise((resolve) => {
                    postData(url, data, response => {
                        if(response) {
                            dispatch({
                                type: "UPDATE_WORKSTREAMS_LIST",
                                list: workstreams.list.map(ws => {
                                    if(ws.id === workstreams.selected.id) {
                                        return {
                                            ...ws,
                                            lead: newLead?.length
                                                ? mapListMemberFormat(newLead[0])
                                                : ws.lead,
                                            workstreamMembers: [
                                                ...ws.workstreamMembers,
                                                ...newUsers.map(nu => mapListMemberFormat(nu))
                                            ]
                                        }
                                    }

                                    return ws;
                                })
                            });

                            resolve(true);
                        }
                    });
                });
            } else {
                return true;
            }
        }

        const handleSave = () => {
            dispatch({ type: "SET_SCREEN_LOADER", Loading: true });

            handleUpdateMembers().then(proceedStep2 => {
                if(proceedStep2) {
                    handleDeleteMembers().then(proceedStep3 => {
                        if(proceedStep3) {
                            handleAddMembers().then(finish => {
                                if(finish) {
                                    if(workstreams.selected.toUpdate) {
                                        handleReassignedTask();
                                        dispatch({ type: "SET_WORKSTREAM_UPDATED", boolean: true });
                                    } else {
                                        dispatch({ type: "UPDATE_WORKSTREAMS_SELECTED",  selected: {} });
                                        dispatch({ type: "SET_SCREEN_LOADER", Loading: false });
                                        dispatch({ type: "SET_WORKSTREAM_UPDATED", boolean: true });

                                        $(`#manageMembers`).modal("hide");
                                        showToast("success", `Users in <strong>${workstreams.selected.workstream}</strong> has been updated`);
                                        handleClose();
                                    }
                                }
                            })
                        }
                    })
                }
            });
        }
        
        const handleReassignedTask = () =>{
            const url =`/api/task/reassignTask/${projectId}`
            const data = { 
                workstreamId: workstreams.selected.id, 
                projectId, 
                data: workstreams.selected.toUpdate 
            };

            putData(url, data, () => {
                dispatch({ type: "UPDATE_WORKSTREAMS_SELECTED",  selected: {} });
                dispatch({ type: "SET_SCREEN_LOADER", Loading: false });

                $(`#manageMembers`).modal("hide");
                showToast("success", `Users in <strong>${workstreams.selected.workstream}</strong> has been updated`);
                handleClose();
            });
        }

        const handleClose = () => {
            this.setState({...this.state, isClose: true});
            dispatch({type: "UPDATE_WORKSTREAMS_SELECTED", selected: {}});
        }
        
        const handleSelect = () => {
            this.setState({...this.state, isClose: false});
        }

        return (
            <div class="modal fade confirm-modal bg-overlay" data-backdrop="static" data-keyboard="false" id="manageMembers">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header pd20 pdl40 pdr40">
                            <div class="row">
                                <div class="col-lg-10 col-md-10 col-sm-10">
                                    <p class="text-size18 brndnTxt-m mb0 mt5">Manage Workstream Members</p>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-2">
                                    <a  class="text-right text-black" data-dismiss="modal" aria-label="Close" onClick={handleClose}>
                                        <i class="material-icons text-black text-size22">close</i>
                                    </a>
                                </div>
                            </div>    
                        </div>
                        <div class="modal-body">
                            <div class="memberSearch">
                                <i class="material-icons searchIcon">search</i>
                                <Search projectId={this.props.projectId} isClose={this.state.isClose} onSelect={handleSelect} avatarBaseUrl={`/api/file/profile_pictures/`} />
                            </div>
                            <div class="memberList">
                                {workstreamMembers.map((m, i) => <Member key={`manageMembers_${m.id}_${i}`} member={m} avatarBaseUrl={`/api/file/profile_pictures/`} />)}
                            </div>
                        </div>
                        <div class="modal-footer bt">
                            <div class="row">
                                <div class="col-lg-4 col-md-4 col-sm-4">
                                    <button type="button" class="btn btnCancel ml0" data-dismiss="modal" onClick={handleClose}>Cancel</button>
                                </div>
                                <div class="col-lg-8 col-md-8 col-sm-8 text-align-right">
                                    <button type="button" class={`btn btnSave`} onClick={handleSave}>Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ManageMembers;
